import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BiTachometer, BiTrip, BiUserVoice } from "react-icons/bi";

type Props = {};

const SiteFeaturesComponent = (props: Props) => {
  const { t } = useTranslation();

  return (
    <section id="features">
      <Container className="p-0">
        <Row className="mx-0 tw-mt-16">
          <Col className="p-0">
            <Row className="gx-0 m-0">
              <Col lg="4" md="4" sm="12" className="tw-p-[10px] ">
                <Row className="m-0">
                  <Col className="bg-tenColor rounded-4 md:tw-w-[380px] md:tw-h-[280px]   md:tw-px-8 md:tw-pt-8 tw-px-5 tw-pt-5 ">
                    <Row>
                      <Col>
                        <span className="features-icon">
                          <BiTachometer className="fs-1 color-thirdColor" />
                        </span>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <h2 className="font-sofiaSans tw-mt-3">
                          {t("home/SiteFeatures/title-01")}
                        </h2>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <p className="font-sofiaSans fs-5">
                          {t("home/SiteFeatures/text-01")}
                        </p>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col lg="4" md="4" sm="12" className="tw-p-[10px]">
                <Row className="m-0">
                  <Col className="bg-tenColor rounded-3  md:tw-w-[380px] md:tw-h-[280px]   md:tw-px-8 md:tw-pt-8 tw-px-5 tw-pt-5">
                    <Row>
                      <Col>
                        <span className="features-icon">
                          <BiUserVoice className="fs-1 color-thirdColor" />
                        </span>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <h2 className="font-sofiaSans tw-mt-3">
                          {t("home/SiteFeatures/title-02")}
                        </h2>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <p className="font-sofiaSans fs-5">
                          {t("home/SiteFeatures/text-02")}
                        </p>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col lg="4" md="4" sm="12" className="tw-p-[10px]">
                <Row className="m-0">
                  <Col className="bg-tenColor rounded-3 md:tw-w-[380px] md:tw-h-[280px]    md:tw-px-8 md:tw-pt-8 tw-px-5 tw-pt-5">
                    <Row>
                      <Col>
                        <span className="features-icon">
                          <BiTrip className="fs-1 color-thirdColor" />
                        </span>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="12">
                        <h2 className="font-sofiaSans tw-mt-3">
                          {t("home/SiteFeatures/title-03")}
                        </h2>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <p className="font-sofiaSans fs-5">
                          {t("home/SiteFeatures/text-03")}
                        </p>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default SiteFeaturesComponent;
